import React from 'react'
import PropTypes from 'prop-types'
import { default as dayjs } from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import duration from 'dayjs/plugin/duration'

import { useUpdateCall } from '../../lib/api/update'
import { useGetMutateCall, getDependencyCall } from '../../lib/api/get'
import { useDependencies } from '../../store/dependencies'
import { useAuthStore } from '../../store/auth'
import { CheckInCard } from './checkInCard'

import checkBoxImg from '../../assets/images/checkbox.svg'
import { NoDataCard } from '../../common/NoDataCard'

dayjs.extend(duration)
dayjs.extend(utc)
dayjs.extend(timezone)

export const StaffAttendance = ({ isLocalEnvironment, routeData }) => {
  const getCallMutation = useGetMutateCall()
  const [dates, setDates] = React.useState(null)
  const [autoRefresh, setAutoRefresh] = React.useState(false)
  const [activityAttenInd, setActivityAttenInd] = React.useState(null)
  const [selectedApplData, setSelectedApplData] = React.useState({
    data: { formData: [] },
  })

  const appState = useAuthStore((state) => state)
  const { setDependency } = useDependencies()
  const [updating, setUpdating] = React.useState(false)

  const getDeps = () => {
    const stateVar = { ...appState }
    if (routeData.hasDependencies) {
      routeData.dependeciesFormAPIS.map(async (api) => {
        stateVar.dependeciesFormAPIS[api] = await getDependencyCall(
          isLocalEnvironment + '/getData',
          api,
          '',
        )
        setDependency(stateVar, stateVar.role, stateVar.roleId)
      })
    }
  }

  const getOnchangeAppl = async (e) => {
    setDates(e)

    await getCallMutation
      .mutateAsync({
        apiURL: isLocalEnvironment + '/getData',
        apiEndpoint: 'staffAttendance',
        params:
          '&checkInDateTime=' +
          dayjs.utc(e).format('YYYY-MM-DD HH:mm:ss') +
          '&timdatesStamp=' +
          dayjs.utc(dates).format('YYYY-MM-DD HH:mm:ss'),
        doPolling: autoRefresh,
        isDynamic: true,
      })
      .then((resp) => {
        setSelectedApplData(resp.formData)
      })
  }

  React.useEffect(() => {
    getDeps()
  }, [])

  const updateCallMutation = useUpdateCall()

  const onSubmit = async (data, type) => {
    setUpdating(true)
    const payload = { ...data }
    payload['attendance'] = 'staff'
    payload['attendanceType'] = type

    await updateCallMutation
      .mutateAsync({
        url: isLocalEnvironment + '/updateData',
        apiEndpoint: type === 3 ? 'check-out-confirmation' : 'check-in-confirmation',
        invalidateWithParams: true,
        data: payload,
        id: payload.staffAttendanceId,
        messageTitle: 'Attendance',
        message: 'Attendance updated successfully!',
        params: '',
        noConfirmation: true,
        isDynamic: true,
      })
      .then(async () => {
        await getCallMutation
          .mutateAsync({
            apiURL: isLocalEnvironment + '/getData',
            apiEndpoint: 'staffAttendance',
            params:
              '&checkInDateTime=' +
              dayjs.utc(dates === null ? new Date() : dates).format('YYYY-MM-DD HH:mm:ss') +
              '&timdatesStamp=' +
              dayjs.utc(dates).format('YYYY-MM-DD HH:mm:ss'),
            isDynamic: true,
          })
          .then((resp) => {
            setSelectedApplData(resp.formData)
            setUpdating(false)
          })
          .catch(() => {
            setUpdating(false)
          })
      })
  }
  const isLayoutDark = sessionStorage.getItem('themeLayout')
    ? sessionStorage.getItem('themeLayout')
    : false
  return (
    <React.Fragment key={isLayoutDark}>
      <div className="trtui-row">
        <div className="trtui-col-12">
          <div className="trtui-page-title-box trtui-d-sm-flex trtui-align-items-center trtui-justify-content-between">
            <h4 className="trtui-mb-sm-0">{routeData.pageTitle}</h4>
            <div className="trtui-row">
              <div key="date" className="trtui-col-md-6">
                <input
                  type="date"
                  className="trtui-form-control"
                  onChange={(e) => {
                    getOnchangeAppl(e.target.value, 'date')
                  }}
                  defaultValue={dates}
                />
              </div>
              <div key="autoRefresh" className="trtui-col-md-6">
                Auto Refresh{' '}
                <input
                  className="trtui-form-check-input"
                  type="checkbox"
                  onChange={() => setAutoRefresh(!autoRefresh)}
                  style={{
                    '--vz-form-check-bg-image': `url(${checkBoxImg})`,
                  }}
                  checked={autoRefresh}
                ></input>
              </div>
            </div>
          </div>
        </div>
      </div>
      {getCallMutation.isLoading ? (
        <div>
          <div
            id="status"
            className="trtui-align-items-center trtui-d-none trtui-d-md-block trtui-justify-content-center"
            style={{
              width: '40px',
              height: '40px',
              position: 'absolute',
              left: '50%',
              top: '50%',
              margin: '-20px 0 0 6.4rem',
            }}
          >
            <div className="trtui-spinner-border trtui-text-primary trtui-avatar-sm" role="status">
              <span className="trtui-visually-hidden">Loading...</span>
            </div>
          </div>
          <div
            id="status"
            className="trtui-align-items-center trtui-d-block trtui-d-md-none trtui-justify-content-center"
            style={{
              width: '40px',
              height: '40px',
              position: 'absolute',
              left: '20%',
              top: '50%',
              margin: '-20px 0 0 6.4rem',
            }}
          >
            <div className="trtui-spinner-border trtui-text-primary trtui-avatar-sm" role="status">
              <span className="trtui-visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      ) : (
        <div className="trtui-row">
          {selectedApplData.length > 0 ? (
            selectedApplData
              .sort((a, b) => new Date(b.checkInDateTime) - new Date(a.checkInDateTime))
              .map((card, cardInd) => (
                <CheckInCard
                  key={cardInd}
                  cardData={card}
                  onSubmit={onSubmit}
                  updating={updating}
                  setActivityAttenInd={setActivityAttenInd}
                  activityAttenInd={activityAttenInd}
                  cardInd={cardInd}
                />
              ))
          ) : (
            <NoDataCard key={isLayoutDark} isLayoutDark={isLayoutDark} />
          )}
        </div>
      )}
    </React.Fragment>
  )
}

StaffAttendance.propTypes = {
  isLocalEnvironment: PropTypes.string,
  routeData: PropTypes.object,
}
